'use client';

import { Autocomplete as MUIAutocomplete, TextField } from '@mui/material';

import type { AutocompleteProps, TextFieldProps } from '@mui/material';

export type AutocompleteBaseProps<
  TOption,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> = Omit<
  AutocompleteProps<TOption, Multiple, DisableClearable, FreeSolo>,
  'renderInput'
> & {
  label?: string;
  placeholder?: string;
  textFieldProps?: TextFieldProps;
};

export function AutocompleteBase<
  TOption,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  label,
  placeholder,
  textFieldProps,
  ...autocompleteProps
}: AutocompleteBaseProps<TOption, Multiple, DisableClearable, FreeSolo>) {
  const { slotProps: textFieldSlotProps, ...restTextFieldProps } =
    textFieldProps ?? {};

  return (
    <MUIAutocomplete
      {...autocompleteProps}
      renderInput={(params) => {
        const { InputProps, InputLabelProps, ...restParams } = params;
        return (
          <TextField
            {...restParams}
            {...restTextFieldProps}
            label={label}
            placeholder={placeholder}
            slotProps={{
              ...textFieldSlotProps,
              input: { ...InputProps, ...textFieldSlotProps?.input },
              inputLabel: {
                ...InputLabelProps,
                ...textFieldSlotProps?.inputLabel,
              },
            }}
          />
        );
      }}
    />
  );
}
